module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_gomoll_sm-4bb80e910ccf8f6f859bbb9c623a5ca3.png";